AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Problem");

AoPS.Alcumus.Models.Problem = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcMBase = AoPS.Alcumus.Models.Base;

	return AlcMBase.BaseModel.extend({
		id_attribute: "problem_id",
		defaults: {
			render_error: false,
			problem_text_bbcode: "",
			problem_text_short: "",
			problem_text_line: "",
			problem_text: "",
			admin: "",
			is_review: false,
			is_review_displayed: false,
			was_displayed: false,
			seen_before: false,
			solved_before: false,
			is_interval: false,
			matrix_size: null,
			// Set in constructor to avoid mutability issues
			user_responses: null, // []
			level_data: null, // []
			tip_list: null, // []
			astats: null, // {}
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
			trial: Associated Trial model; only set when problem is finished
		*/

		initialize: function () {
			this.set("user_responses", []);
			this.set("level_data", []);
			this.set("tip_list", []);
			this.set("astats", {});

			this.setLoader(
				new LoadUtils.LoadManager({
					loadHandler: this.loadProblem,
					context: this,
				})
			);
		},

		loadProblem: function (callback) {
			// We usually don't get here. Loading a user loads their current problem,
			// changing a focus replaces the loader + loadHandler, and submitting
			// a final response (currently) runs all the finish problem scripts.
			// Even if we do get here, finish_problem is very safe and can deal
			// with any data state.
			this.get("user").requestLoad(function (ok1) {
				if (!ok1) {
					return callback(ok1, {});
				}
				AlcMBase.ajax.run(
					"finish_problem",
					{
						user_id: this.get("user").id,
					},
					_.bind(function (ok2, data) {
						if (!ok2) {
							return callback(ok2, data);
						}
						this.get("user").unpack(data.response.user);
						callback(ok2, {});
					}, this)
				);
			}, this);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			// Front-end ignores whether back-end thinks problem is viewed or not.
			// The problem may have been viewed, but log entries may not have been,
			// and was_displayed is used to determine whether to send a notice of viewing.
			delete data.was_displayed;

			this.setFields(data);
			this.markAsLoaded(true);
		},

		markAsViewed: function () {
			// Called once per session+assigned problem pair. (see unpack comment)
			if (!this.get("was_displayed")) {
				this.set("was_displayed", true);
				AlcMBase.ajax.run(
					"problem_viewed",
					{
						user_id: this.get("user").id,
						problem_id: this.id,
					},
					function () {}
				);
			}
		},

		finish: function (next_problem_data, callback, context) {
			this.get("user").finishCurrentProblem(
				next_problem_data,
				callback,
				context
			);
		},

		hasResponse: function () {
			return !!this.get("user_responses").length;
		},

		// Assumes a falsy submission is a request to giveup. View code is
		// responsible for not calling this function when the user hasn't entered
		// a response.
		// The callback, if ok is true, will receive a result key and possibly
		// a next_problem key in the second parameter. The result is not 'U' if
		// and only if the problem was not finished by this trial. If the problem
		// was finished, next_problem will have the data to unpack for the next
		// problem, which calling code should send to the finish method.
		submitResponse: function (response, callback, context) {
			var giveup = !response;
			response = response || "give up";

			// Repeated submission check
			if (this.is_submitting) {
				return;
			}
			this.is_submitting = true;

			callback = LoadUtils.makeCallback(callback, context);

			AlcMBase.ajax.run(
				"submit_response",
				{
					user_id: this.get("user").id,
					problem_id: this.id,
					response: response,
					giveup: giveup ? 1 : 0,
					advance_focus: this.get("user").get("master").get("is_self_paced")
						? 0
						: 1, // When alcumus is played from the alcumus page, full is undefined
				},
				_.bind(function (ok, data) {
					this.is_submitting = false;
					if (!ok) {
						return callback(ok, data);
					}

					var trials = [];
					if (data.response.trial) {
						trials = this.get("user")
							.get("trials")
							.unpackAll([data.response.trial], "trial_id");
					} else if (data.response.current_problem) {
						this.unpack(data.response.current_problem);
					}

					if (trials && trials.length) {
						this.set("trial", trials[0]);
					}

					var user_data = data.response.user;
					var next_problem_data;
					if (user_data) {
						// If user data provided current_problem data, it is for the next
						// problem. Don't unpack it yet; we haven't switched problems.
						next_problem_data = user_data.current_problem;
						delete user_data.current_problem;

						this.get("user").unpack(user_data);
					}

					// Sending the next problem's data to the callback will get it
					// unpacked at the right time, if the calling code is written right.
					callback(ok, {
						result: data.response.result,
						next_problem: next_problem_data,
					});
				}, this)
			);
		},

		giveUp: function (callback, context) {
			this.submitResponse(false, callback, context);
		},
	});
})();
